'use client';

import { useRouter } from 'next/navigation';

import { Connectivity, OptionType, PlanType } from '@app-types/product';

import { panierRoute } from '@helpers/routes';

import { cartStore } from '@stores/cart';

export function useHome() {
    const router = useRouter();
    const {
        selectedPlan,
        setSelectedPlan,
        selectedOption,
        setSelectedOption,
        addToCart,
        byouCart,
        selectedFaiOption,
        selectedFaiProduct,
        setSelectedFaiProduct,
        setSelectedFaiOption,
        selectedNetwork,
        setSelectedNetwork,
        temporarilySelectedPlan,
        setTemporarilySelectedPlan,
        setTemporarilySelectedFaiProduct,
        temporarilySelectedFaiProduct,
        otisConfigurator,
        setOtisConfigurator,
    } = cartStore((state) => state);

    const handleAddToCart = () => {
        if (!selectedPlan) {
            if (selectedFaiProduct) {
                // const trackerId = await trackerIdService();
                const urlParams = {
                    faiOptionId: selectedFaiOption ?? undefined,
                    focus: `${selectedFaiProduct.range_ng}_${selectedFaiProduct.commercial_series}_${selectedFaiProduct.product.technology}`,
                };

                return router.push(OFFRES_INTERNET.eligPanierMixte(urlParams));
            }
            return;
        }

        const cartOptions: OptionType[] = [];
        if (selectedOption?.gencode) {
            const t = selectedPlan.options.find((o) => o.gencode === selectedOption?.gencode);
            if (t) cartOptions.push(t);
        }
        addToCart({
            product: { ...selectedPlan },
            options: cartOptions,
        });
        if (selectedFaiProduct) {
            let neededProducts: string[] = [];
            if (selectedPlan.neededElements?.length) {
                const autoAdd = selectedPlan.neededElements.flatMap((el) =>
                    el.alternatives.map((alt) => alt.identifier),
                );
                neededProducts = [...autoAdd];
            }

            const urlParams = {
                planId: selectedPlan?.gencode,
                neededProducts: neededProducts.length > 0 ? neededProducts.join(',') : undefined,
                optionsId:
                    selectedPlan.connectivity === Connectivity.FOUR_G && selectedOption?.gencode
                        ? selectedOption?.gencode
                        : undefined,
                faiOptionId: selectedFaiOption ?? undefined,
                focus: `${selectedFaiProduct.range_ng}_${selectedFaiProduct.commercial_series}_${selectedFaiProduct.product.technology}`,
            };

            return router.push(OFFRES_INTERNET.eligPanierMixte(urlParams));
        }
        router.push(panierRoute.path);
    };

    const handleAddCatalogProductToCart = ({
        product,
        options,
    }: {
        product: PlanType;
        options: OptionType[];
    }): void => {
        addToCart({
            product,
            options,
        });
        router.push(panierRoute.path);
    };

    return {
        selectedPlan,
        selectedOption,
        setSelectedOption,
        setSelectedPlan,
        selectedFaiProduct,
        setSelectedFaiProduct,
        addToCart,
        handleAddToCart,
        byouCart,
        handleAddCatalogProductToCart,
        otisConfigurator,
        setOtisConfigurator,
        setSelectedFaiOption,
        selectedFaiOption,
        selectedNetwork,
        setSelectedNetwork,
        temporarilySelectedPlan,
        setTemporarilySelectedPlan,
        setTemporarilySelectedFaiProduct,
        temporarilySelectedFaiProduct,
    };
}

export const OFFRES_INTERNET = {
    eligPanierMixte: ({
        planId,
        neededProducts,
        optionsId,
        faiOptionId,
        trackerId,
        focus,
    }: {
        planId?: string;
        neededProducts?: string;
        optionsId?: string;
        faiOptionId?: string;
        trackerId?: string;
        focus: string;
    }): string => {
        const baseUrl = '/offres-internet/test-eligibilite-panier-mixte';
        const params = new URLSearchParams();
        if (planId) params.append('plan_id', planId);
        if (optionsId) params.append('options_id', optionsId);
        if (faiOptionId) params.append('fai_options', faiOptionId);
        if (trackerId) params.append('tracker_id', trackerId);
        if (neededProducts) params.append('needed_products', neededProducts);

        params.append('focus', focus);

        const queryString = params.toString();
        return `${baseUrl}?${queryString}`;
    },
};
